exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  background-color: #172894;\n  color: whitesmoke;\n  font-family: \"Microsoft YaHei\" ! important;\n  font-size: 30px;\n}\n.header {\n  height: 100px;\n  line-height: 100px;\n  font-size: 45px;\n}\n.content {\n  padding-top: 40px;\n}\n.footer {\n  margin-top: 15px;\n  height: 100px;\n  font-size: 25px;\n  padding-left: 30px;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n#faceStyle {\n  width: 400px;\n  height: 330px;\n  position: fixed;\n  top: 230px;\n  left: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./src/views/faceCheck/Check.less
// module id = 3pbd
// module chunks = 1